import $ from 'jquery';

const languageSelectionTrigger = document.getElementById('js-languageSelectionTrigger');
const languageSelectionTarget = document.getElementById('js-languageSelectionTarget');

$(languageSelectionTrigger).on('click', function() {
  if (! $(languageSelectionTarget).is(':visible')) {
    $(languageSelectionTarget).closest('.page-languageSelector').addClass('active');
  }

  else {
    $(languageSelectionTarget).closest('.page-languageSelector').removeClass('active');
  }
});